import { render, staticRenderFns } from "./OrderTimelineStatusItem.vue?vue&type=template&id=fca09f9a&"
import script from "./OrderTimelineStatusItem.vue?vue&type=script&lang=js&"
export * from "./OrderTimelineStatusItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports